// Brand content imported & preserved from the JohnnyMart GitHub repository.
export const BRAND = {
  name: "JohnnyMart",
  tagline: "Your Place for Happiness",
  heroHeadline: "Great finds. Cool stuff. Good vibes.",
  heroSub:
    "Designer bags, collectibles, electronics, glassware, clothes, toys, and one-of-a-kind treasures at fair prices.",
  location: "Ponte Vedra Beach, FL",
  email: "ShopJohnnyMart@yahoo.com",
  about:
    "JohnnyMart is a treasure-hunt shop. Inventory changes often, so customers can always find something new, useful, collectible, or just plain cool.",
};

export const QUICK_FACTS = [
  { icon: "Sun", title: "Beach-town vibes", text: "Florida feel, friendly service." },
  { icon: "Tag", title: "Great deals", text: "Quality finds at fair prices." },
  { icon: "PackageOpen", title: "New finds", text: "Fresh inventory added often." },
  { icon: "Smile", title: "Happiness", text: "Good items, good people, good vibes." },
];

export const GUARANTEE = [
  "Clear descriptions",
  "Fair prices",
  "Secure packaging when shipping",
  "Local, honest service",
  "5-star experience mindset",
];

export const POLICIES = {
  shipping: {
    title: "Shipping & Local Pickup",
    intro:
      "We package every item carefully and ship promptly. Local pickup is available in Ponte Vedra Beach, FL.",
    sections: [
      {
        heading: "Handling & shipping times",
        body:
          "In-house items ship within 1–3 business days of payment via USPS Ground Advantage. Shipping is calculated automatically at checkout based on the item's weight, and tracking is emailed to you when your order ships.",
      },
      {
        heading: "Gateway items (shipped from supplier)",
        body:
          "Items in The Gorilla Gateway, marked \"Ships from supplier,\" are fulfilled directly by our trusted partner warehouses. These typically arrive in 7–20 business days depending on the item and destination. You'll receive tracking as soon as it's available.",
      },
      {
        heading: "Local Pickup",
        body:
          "Choose Local Pickup at checkout to arrange a free, in-person handoff in the Ponte Vedra Beach area. We'll coordinate a convenient time by email after your order is placed.",
      },
      {
        heading: "Questions about an item?",
        body:
          "Inventory changes often. Message us to confirm availability, request more photos, or ask about combined shipping.",
      },
    ],
  },
  returns: {
    title: "Returns & Refunds",
    intro: "We stand behind every item with The Gorilla Guarantee. Please read our return rules below.",
    sections: [
      {
        heading: "When a return is accepted",
        body:
          "You have 7 calendar days after confirmed delivery to request a return only when the item is materially different from its description, the wrong item was delivered, or it arrived damaged.",
      },
      {
        heading: "Reporting shipping damage",
        body:
          "Please report shipping damage within 48 hours when reasonably possible, and include photographs of both the item and the packaging so we can resolve it quickly.",
      },
      {
        heading: "What is not eligible",
        body:
          "Returns are not accepted for buyer's remorse, incorrect fit, changing your mind, or for characteristics that were accurately shown or described in the listing. Many items are pre-owned and described honestly with photos.",
      },
      {
        heading: "Return condition & shipping",
        body:
          "Approved items must be returned in the same condition in which they were received. JohnnyMart pays reasonable return shipping when we made an error or materially misrepresented the product.",
      },
      {
        heading: "If we can't fulfill your order",
        body:
          "When an order cannot be fulfilled because an item is unavailable, sold twice, or lost before shipment, we automatically cancel the order and issue a full refund, including shipping.",
      },
    ],
  },
  pickup: {
    title: "Local Pickup Policy",
    intro: "Free local pickup is available by appointment in the Ponte Vedra Beach, Florida area.",
    sections: [
      {
        heading: "How pickup works",
        body:
          "Choose Local Pickup at checkout. After your payment is confirmed, we email you a \"Ready for Pickup\" message and arrange a convenient time. The exact pickup location is shared privately once your appointment is set.",
      },
      {
        heading: "How long we hold items",
        body:
          "Paid pickup orders are held for 7 calendar days after the \"Ready for Pickup\" notification. We send friendly reminders around day 3 and day 6.",
      },
      {
        heading: "If an item isn't collected",
        body:
          "If the order isn't collected or an extension arranged by the end of day 7, we cancel the order, refund you in full, and return the item to inventory. We never keep both the item and your payment. Need more time? Just ask and we'll extend your deadline.",
      },
      {
        heading: "What to bring",
        body:
          "Please have your order number and confirmation email ready at pickup.",
      },
    ],
  },
  condition: {
    title: "Product Condition Policy",
    intro: "JohnnyMart sells both new and pre-owned items. We describe condition honestly so you know exactly what you're getting.",
    sections: [
      {
        heading: "Condition labels we use",
        body:
          "New / factory sealed, New with tags, New without tags, Open box, Like new, Excellent used condition, Good used condition, Fair condition, and For parts or repair.",
      },
      {
        heading: "Condition details",
        body:
          "Every resale item includes a written description of any noticeable wear, stains, damage, missing parts, repairs, odors, packaging damage, or tag condition. Both the condition label and details appear on the product page.",
      },
      {
        heading: "Honest descriptions",
        body:
          "We never describe used merchandise as new. If you have a question about an item's condition before buying, message us and we'll send more photos or details.",
      },
    ],
  },
  authenticity: {
    title: "Authenticity & Brand Policy",
    intro: "JohnnyMart makes reasonable efforts to identify merchandise accurately and does not knowingly sell counterfeit goods.",
    sections: [
      {
        heading: "How we handle branded items",
        body:
          "Designer- or luxury-branded items may be withheld from sale while we review them. We do not describe an item as authentic, genuine, or certified based only on its brand name, title, photos, or a keyword.",
      },
      {
        heading: "Authentication status",
        body:
          "An authentication status is only shown when supporting information exists (for example, documentation reviewed or third-party authentication). If we can't reasonably verify a branded item, it stays withheld rather than being mislabeled.",
      },
      {
        heading: "No false affiliations",
        body:
          "JohnnyMart is an independent resale shop and is not affiliated with Louis Vuitton, Gucci, or any other brand. If you believe a listing is inaccurate, please contact us and we'll review it promptly.",
      },
    ],
  },
  faq: {
    title: "Frequently Asked Questions",
    intro: "Quick answers to common questions. Don't see yours? Just contact us.",
    sections: [
      { heading: "Do you ship, or is it pickup only?", body: "Both. Most items can ship via USPS (cost calculated by weight at checkout), and free local pickup is available in Ponte Vedra Beach, FL." },
      { heading: "How is shipping calculated?", body: "Automatically at checkout based on the item's weight, using USPS Ground Advantage. You'll see the exact cost before you pay." },
      { heading: "Are your items new or used?", body: "A mix. Every item shows a clear condition label and detailed condition notes. We describe pre-owned items honestly." },
      { heading: "Can I return something?", body: "Yes, within 7 days of delivery if the item is materially not as described, wrong, or damaged. See our Returns & Refunds policy for details." },
      { heading: "How do I pay?", body: "Securely with credit/debit card (via Stripe) or PayPal. Local pickup orders can also be arranged." },
      { heading: "How do I know an item is still available?", body: "One-of-a-kind items show \"Sold Out\" once purchased. You can always message us to confirm availability or ask about similar items." },
    ],
  },
  accessibility: {
    title: "Accessibility Statement",
    intro: "JohnnyMart is committed to making our store usable for everyone, including people with disabilities.",
    sections: [
      { heading: "Our commitment", body: "We aim to follow widely accepted accessibility best practices: descriptive image text, keyboard navigation, readable contrast, labeled form fields, and clear error messages." },
      { heading: "Ongoing improvement", body: "Accessibility is an ongoing effort. We continue to review and improve the site over time." },
      { heading: "Need help or found a barrier?", body: "If you have trouble using any part of our site, email ShopJohnnyMart@yahoo.com and we'll help you complete your order and fix the issue." },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    intro: "Your information is used only to fulfill your order and communicate with you.",
    sections: [
      {
        heading: "What we collect",
        body:
          "We collect the name, email, phone, and shipping address you provide at checkout so we can process and deliver your order. We never sell your information.",
      },
      {
        heading: "Payments",
        body:
          "Card payments are processed securely by Stripe, and PayPal payments by PayPal. JohnnyMart never sees or stores your full card details.",
      },
      {
        heading: "Contact",
        body:
          "Questions about your data, or want it removed? Email ShopJohnnyMart@yahoo.com and we'll respond as soon as we can.",
      },
    ],
  },
  terms: {
    title: "Terms of Service",
    intro: "Friendly, honest terms for a friendly, honest shop.",
    sections: [
      {
        heading: "Availability",
        body:
          "Inventory changes often and many items are one-of-a-kind. Availability is confirmed at the time your order is processed; if an item sells out, we'll promptly refund any affected order.",
      },
      {
        heading: "Pricing & payment",
        body:
          "Prices are shown in USD and any applicable shipping is calculated at checkout. We accept credit/debit cards (via Stripe), PayPal, and local cash/handoff for pickup orders.",
      },
      {
        heading: "Contact",
        body: "For any questions about an order, email ShopJohnnyMart@yahoo.com and we'll be glad to help.",
      },
    ],
  },
};
